{
  "categoryCard": {
    "dropdown": {
      "translationButton": "Ver traducciones",
      "editButton": "Editar",
      "deleteButton": "Eliminar"
    },
    "questionsCount": "{{questionCount}} preguntas",
    "noQuestions": "Aún no hay preguntas",
    "exploreQuestionsButton": "Explorar otras preguntas",
    "addQuestionsButton": "Agregar preguntas",
    "lastAskedText": "Última pregunta",
    "notAskedText": "Aún no preguntado",
    "satisfactionScoreText": "Puntuación de satisfacción"
  },
  "teamPerformanceCard": {
    "comparedToAverage": {
      "more": "más que el promedio de la empresa",
      "less": "menos que el promedio de la empresa",
      "same": "igual que el promedio de la empresa"
    },
    "companyBaseline": "Referencia de la empresa {{score}}",
    "notEnoughResponses": "No hay suficientes respuestas"
  },
  "insightsCard": {
    "responseCount": "{{responseCount}} respuestas"
  },
  "integrationCard": {
    "status": {
      "connected": {
        "verified": "Verificado",
        "configured": "Configurado",
        "connected": "Conectado",
        "managed": "Gestionado"
      },
      "notConnected": {
        "verify": "Verificar",
        "configure": "Configurar",
        "connect": "Conectar",
        "manage": "Gestionar"
      }
    }
  },
  "questionHistoryRow": {
    "responseCount_one": "{{formattedResponses}} respuesta",
    "responseCount_other": "{{formattedResponses}} respuestas",
    "insufficientResponses": "Respuestas insuficientes",
    "questionButton": "Ver detalles"
  },
  "manageCategoryPopup": {
    "title": "Paso 1/2",
    "buttonNewCategory": "Agregar nueva categoría",
    "buttonEditCategory": "Editar categoría",
    "changeButton": "Cambiar ícono",
    "nextStep": "Siguiente paso",
    "cancelButton": "Cancelar",
    "inputs": {
      "categoryPlaceholder": "Ingrese el nombre de la categoría",
      "categoryLabel": "Nombre de la categoría",
      "descriptionPlaceholder": "Ingrese la descripción",
      "descriptionLabel": "Descripción"
    }
  },
  "iconPickerCategoryPopup": {
    "buttons": {
      "backButton": "Regresar",
      "choseIconButton": "Elegir ícono para la categoría"
    },
    "categories": {
      "performance": "Desempeño",
      "communication": "Comunicación",
      "teamCulture": "Cultura del equipo",
      "learning": "Aprendizaje"
    }
  },
  "translationOverviewCategory": {
    "title": "Paso 2/2",
    "description": "Verificar traducción a otros idiomas",
    "subtitle": "Usamos traducción por IA, por lo que el resultado puede contener errores",
    "buttons": {
      "backButton": "Regresar",
      "buttonNewCategory": "Agregar categoría",
      "buttonEditCategory": "Editar categoría"
    },
    "categoryNameText": "Nombre de la categoría",
    "descriptionText": "Descripción"
  },
  "changeQuestionPopup": {
    "title": "Cambiar pregunta",
    "buttons": {
      "cancelButton": "Cancelar",
      "changeButton": "Cambiar pregunta"
    },
    "inputs": {
      "labelCategory": "Categoría",
      "placeholderCategory": "Seleccionar categoría",
      "labelQuestion": "Pregunta",
      "placeholderQuestion": "Seleccionar pregunta"
    },
    "questionHistory": {
      "lastAskedHint": "Última pregunta {{date}}",
      "empty": "(Vacío)"
    },
    "errors": {
      "updateFailed": "No se pudo actualizar la pregunta del calendario. Inténtalo de nuevo."
    }
  },
  "blocksSidebar": {
    "placeholder": "Buscar bloques",
    "filters": {
      "all": "Todos",
      "text": "Texto",
      "numbers": "Números",
      "graphs": "Gráficos"
    }
  },
  "dashboardSidebar": {
    "role": "Rol",
    "profileSettings": "Configuración del perfil",
    "signOut": "Cerrar sesión",
    "powered": "Desarrollado por"
  },
  "changeIndicator": {
    "noChange": "Sin cambios"
  },
  "categoryDistributionCard": {
    "questionsCount_one": "{{count}} pregunta",
    "questionsCount_other": "{{count}} preguntas"
  },
  "gaugeChart": {
    "enpsScore": "Puntaje eNPS"
  },
  "pieChartSimple": {
    "previously": "{{companyScore}} % anteriormente",
    "companyBaseline": "Línea base de la empresa:"
  },
  "tagList": {
    "noTags": "Sin etiquetas"
  },
  "surveyCard": {
    "dropdown": {
      "edit": "Editar",
      "delete": "Eliminar"
    },
    "useTemplate": "Usar plantilla",
    "preview": "Vista previa"
  },
  "translationOverviewQuestion": {
    "questionNameText": "Nombre de la pregunta"
  },
  "calendar": {
    "cancel": "Cancelar",
    "apply": "Aplicar"
  },
  "categoryPopup": {
    "translationEditItem": {
      "title": "Editar traducción",
      "cancel": "Cancelar",
      "save": "Guardar cambios"
    }
  },
  "shareReportPopup": {
    "title": "Compartir informe",
    "accessReport": "Acceso al informe",
    "anyoneWithLink": "Cualquiera con el enlace",
    "copyLink": "Copiar enlace"
  },
  "surveyBuilderPopup": {
    "surveyInfoPopup": {
      "title": "Editar traducción",
      "tags": "Etiquetas",
      "cancel": "Cancelar",
      "save": "Guardar cambios"
    },
    "surveyPublishPopup": {
      "title": "Publicar una encuesta",
      "surveyTitle": "Título de la encuesta",
      "surveyDescription": "Descripción de la encuesta",
      "tags": "Etiquetas",
      "audienceSize": "Tamaño de la audiencia",
      "startDate": "Fecha de inicio",
      "distributionMethods": "Métodos de distribución",
      "cancel": "Cancelar",
      "save": "Guardar cambios"
    },
    "surveyQuestionPopup": {
      "title": "Editar traducción",
      "options": "Opciones",
      "cancel": "Cancelar",
      "save": "Guardar cambios"
    }
  },
  "userManagementRow": {
    "seeDetails": "Ver detalles",
    "leaderTag": "Líder",
    "roleChangeNotAllowed": "Solo los administradores pueden cambiar los roles de usuario."
  },
  "errorScreen": {
    "notFound": {
      "title": "Pagina no encontrada",
      "description": "Parece que esta pagina se movio o ya no existe. Volvamos al camino: ve al Resumen o vuelve a la pagina anterior.",
      "secondaryCta": "Ir a la pagina anterior",
      "primaryCta": "Ir al Resumen"
    },
    "generic": {
      "title": "Algo no salio como esperabamos",
      "description": "Ya estamos trabajando para restaurarlo todo. Intentalo de nuevo o vuelve atras para continuar donde todo funciona correctamente.",
      "secondaryCta": "Intentar de nuevo",
      "primaryCta": "Volver atras"
    }
  },
  "deliveryPausedBanner": {
    "title": "La entrega de preguntas está en pausa",
    "description": {
      "manual": "La entrega de tus preguntas está en espera. Contacta con soporte para obtener más información.",
      "subscription_canceled": "Tu suscripción ha sido cancelada y la entrega de preguntas se ha detenido. Contacta con soporte para reactivarla.",
      "subscription_past_due": "No pudimos procesar tu pago. La entrega de preguntas está en pausa hasta que se actualice el pago.",
      "subscription_unpaid": "Tu pago está vencido y la entrega de preguntas se ha suspendido. Contacta con soporte para resolverlo.",
      "subscription_paused": "Tu suscripción está en pausa y la entrega de preguntas está detenida. Contacta con soporte para reanudarla."
    },
    "contactSupport": "Contactar con soporte"
  },
  "globalBanner": {
    "dismissFailed": "No se pudo guardar su elección. Inténtelo de nuevo."
  },
  "setupIncompleteBanner": {
    "title": "Completa la configuración para empezar a recibir comentarios",
    "description": "Configura tu organización para comenzar a recopilar opiniones del equipo. Toma menos de 15 minutos.",
    "completeSetupMessage": "Completar configuración"
  }
}
